export default {
  align: 'center',
  emptyBtn: false,
  submitBtn: false,
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      search: true,
      cell: true,
      clearable: false,
      disabled: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',

    },
    {
      label: '车辆身份',
      span: 8,
      disabled: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_manage_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'carManageType',
    },
    {
      label: '车牌号',
      prop: 'plateNumber',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '车型大小',
      span: 8,
      disabled: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'bigOrSmallCar',
    },
    {
      label: '主/副车',
      span: 8,
      disabled: true,
      type: 'select',
      dicData: [{
        dictValue:'副车',
        dictKey:'0',
      },{
        dictValue:'主车',
        dictKey:"1",
      }],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'isMainCar',
    },
    {
      label: '车位编号',
      prop: 'parkingSpaceNames',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '客户姓名',
      prop: 'personName',
      type: 'input',
      maxlength:10,
      span: 8,
      disabled: true,
      rules:[
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur',
        }],
    },
    {
      label: '客户手机',
      prop: 'personPhone',
      type: 'input',
      maxlength:11,
      span: 8,
      disabled: true,
      rules:[
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
        { min: 11, max: 11, message: '长度为11个字符', trigger: 'blur' },
        { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
      ],
    },
    
    {
      label: '房产信息',
      prop: 'roomName',
      type: 'input',
      span: 8,
      disabled: true,
      readonly:true,
    },
    {
      label: '收费套餐',
      prop: 'feeRuleId',
      type: 'tree',
      span: 8,
      dicData: [],
      disabled: true,
      formslot:true,
      props: {
        label: 'setmealName',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费标准',
          trigger: 'blur',
        },
      ],
    },
    // {
    //   label: '收费套餐',
    //   span: 8,
    //   hide: true,
    //   disabled:true,
    //   type: 'input',
    //   display:false,
    //   prop: 'feeRuleName',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择收费套餐',
    //       trigger: 'blur',
    //     },
    //   ],
    // },
    {
      label: '开始日期',
      prop: 'effectTime',
      type: 'date',
      span: 8,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      rules: [
        {
          required: true,
          message: '请选择开始日期',
          trigger: 'blur',
        },
      ],
      clearable:false,
      disabled: false,
    },
    {
      label: '租赁时长',
      prop: 'cycleNum',
      disabled: false,
      type: 'tree',
      dicData: [],
      span: 8,
      formslot:true,
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      rules: [
        {
          required: true,
          message: '请选择租赁时长',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '结束日期',
      prop: 'expiredTime',
      type: 'date',
      span: 8,
      disabled: true,
    },
    {
      label: '优惠规则',
      prop: 'discountRuleId',
      type: 'tree',
      dicData: [],
      span: 8,
      formslot:true,
      disabled: true,
      props: {
        label: 'discountName',
        value: 'id',
      },
      rules: [
        {
          required: false,
          message: '请选择优惠规则',
          trigger: 'blur',
        },
      ],
    },
    // {
    //   label: '优惠规则',
    //   span: 8,
    //   hide: true,
    //   disabled:true,
    //   type: 'input',
    //   display:false,
    //   prop: 'discountRuleName',
    // },
    {
      label: '优惠金额',
      prop: 'discountAmount',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '应缴金额',
      prop: 'shouldAmount',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '实缴金额',
      prop: 'payAmount',
      type: 'input',
      formslot: true,
      span: 8,
      disabled: true,
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      span: 8,
      display:false,
      disabled: true,
    },

    {
      label: '余额',
      prop: 'balance',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '收款方式',
      prop: 'payType',
      type: 'input',
      span: 8,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款类型',
      prop: 'payScene',
      type: 'input',
      span: 8,
      display: true,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款码',
      prop: 'authCode',
      type: 'input',
      span: 8,
      display: true,
      disabled: false,
      formslot: true,
    },
    {
      label: '车辆类别',
      span: 8,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'carCategory',
    },
    {
      label: '车辆类型',
      span: 8,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'carType',
    },
    {
      label: '备注',
      span: 24,
      hide: true,
      // disabled:true,
      type: 'textarea',
      maxlength: 200,
      display:false,
      prop: 'description',
    },

  ],
};

